<template>
	<div class="faqs">
		<!-- input class="question-input"
			    autocomplete="off"
				placeholder="יש לכם שאלה? כתבו אותה כאן"
				v-bind:value="viewedQuestion"
				@input="onInput($event.target.value)" aria-label="יש לכם שאלה? כתבו אותה כאן"/>
		<div class="current-search-results" v-if="searchOptions.length > 0">
			<div class="question" tabindex="0" v-for="question in searchOptions" v-on:click="ChooseFAQ(question)">
				<p><label tabindex="-1" role="label" class="question-label" >{{question.question}}</label></p>
			</div>
		</div -->
		

		<div class="current-question" v-if="faqList.length > 0">
			<p v-if="searchNotInitiated">{{ faqList[chosenQ].question }}</p>
			<p v-html="faqList[chosenQ].answer"></p>
		</div>
		<div class="other-questions" dir="ltr">
			
			<div class="question" role="button" style="margin-top:5px;" v-for="question in similarQuestions" dir="rtl" tabindex="0"  v-on:keyup.enter="ChooseFAQ(question)"  v-on:click="ChooseFAQ(question)" >
				<label tabindex="-1" role="label" class="question-label">{{question.question}}</label><br>
			</div>
		</div>
		
	</div>
</template>

<script>
  import axios from 'axios'
  var APIbase = "https://yard-bands.herokuapp.com"
  export default {
    components: {
      
    },
	created () {
		this.fetchFAQ();
	},
	data() {
		return {
			faqList:[],
			chosenQ: 0,
			searchNotInitiated: true,
			searchOptions:[],
			similarQuestions:[],
			viewedQuestion:"",
			keyValue: false
		}
	},
	methods: {
	    fetchFAQ() {
			axios.get(APIbase+'/faqs').then(response => {
				this.faqList = response.data
				this.similarQuestions = response.data.slice(1)
				this.chosenQ = 10;
			})
		},
		ChooseFAQ(question) {
			this.keyValue = !this.keyValue
			this.chosenQ = this.faqList.indexOf(question);
			this.viewedQuestion = ""
			
			//for similar questions
			/*this.similarQuestions =  this.searchOptions.filter(function(quest){ return quest.id !=  question.id })
			for (var i = 0; i < this.faqList.length && this.similarQuestions.length < 5; i++) {
				var currQuestion  = this.faqList[i];
				if (! this.similarQuestions.find(function(elem){ return elem.id == currQuestion})) {
					this.similarQuestions.push(currQuestion)			
				}
			}*/
			
			this.searchOptions = []
		},
		onInput(currentInput) {
			this.viewedQuestion = currentInput
			if (currentInput == "") {
				this.searchOptions = []
			}
			else {
				
				var a = this.faqList.filter(function(quest){ return quest.question.includes(currentInput) })
				var b = this.faqList.filter(function(quest){ return quest.answer.includes(currentInput) });
				var c = a.concat(b.filter(function (item) { return a.indexOf(item) < 0;}));
				
				if (c.length <= 5) {
					this.searchOptions = c;
				}
				else {
					this.searchOptions = c.slice(0,5);
				}
			}
		}
	}
	
  }
</script>



// WEBPACK FOOTER //
// FAQ.vue?15ca76b1